import { Map } from "immutable";
import actions from "./actions";

const initState = new Map({
  isLoggedIn: false,
  isChecking_LoggedIn: false,
  user_profile: {},
});

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case "persist/REHYDRATE":
      if (action.payload) {
        return new Map(action.payload.Auth);
      } else {
        return state;
      }
    case actions.LOGIN_SUCCESS:
      return state.set("idToken", action.token);
    case actions.LOGOUT:
      return initState;
    case actions.LOGGED_IN:
      return state.set("isLoggedIn", action.isLoggedIn);
    case actions.ISCHECKING_LOGGED_IN:
      return state.set("isChecking_LoggedIn", action.isChecking_LoggedIn);
    case actions.USER_AUTH_PROFILE:
      return state.set("user_profile", action.user_profile);
    default:
      return state;
  }
}
